import * as React from 'react';
import { Input as HenInput } from '@highereducation/hen-ui';
import { fieldName } from '../submit';
import {
  FieldLabel,
  FieldErrorMessage,
  type FieldComponentProps,
} from './parts';

/** FILEUPLOAD field — hen-ui `Input type="file"`. Multiple + accept mapped from GF config. */
export function FileUploadField({ field, formId, error }: FieldComponentProps) {
  const name = fieldName(formId, field.id);
  const accept = field.allowedExtensions?.length
    ? field.allowedExtensions
        .map((ext) => `.${ext.replace(/^\./, '')}`)
        .join(',')
    : undefined;

  return (
    <>
      <FieldLabel field={field} htmlFor={name} />
      <HenInput
        id={name}
        name={name}
        type='file'
        accept={accept}
        multiple={Boolean(field.canAcceptMultipleFiles)}
        required={Boolean(field.isRequired)}
        error={Boolean(error)}
      />
      <FieldErrorMessage error={error} />
    </>
  );
}
